/// <reference path="../../typings/references.d.ts" />
module PartnershipsModule {

    angular
        .module('app')
        .constant('dataAccessUrl', '//pp-cuev-func-t.azurewebsites.net/api/v1');

}